import React from 'react';

export default function GlobalErrorsBox(props) {
	// console.log('GlobalErrorsBox', props);

	const { globalErrors = [] } = props;

	if (globalErrors && globalErrors.length) {
		return (
			<div className="GlobalError my-3">
				{/*<div>{globalErrors}</div>*/}
				<div>{globalErrors.map((error) => <div key={error}>{error}</div>)}</div>
			</div>
		);
	}
	return null;
}
